<template>

    <div id="wrapper" style="height:100vh;">

        <div id="top" class="top">
            <p class="text-center mytitle mb-1" style="color: var(--primary-color)">resumen semanal matriz crazyboy 14-09-2020</p>
            <p class="top_appinfo text-center">7878 files in 1516 folders (<span id="tot_size">996935606196</span>)</p>
        </div>

        <div id="loading" class="loading"><b>Loading...</b>
            <p class="loading_info">(if nothing happens, make sure javascript is enabled and allowed to execute)</p></div>
        <div id="content" class="content">

            <div id="tree" class="tree_div"></div>

            <div id="files_div" class="files_div">
                <div id="path_info" class="path_info"></div>
                <div id="file_list" class="file_list"></div>
                <div id="num_files" class='num_files'></div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from "@/store/store";
    // import $ from 'jquery'
    import initF from "@/assets/crazyboy-data";


    export default {
        name: "FileExplorer",
        data() {
            return {
                datosCargados: false,
                isJSFileExplorerAttached: store.state.isJSFileExplorerAttached,
                child: null
            }
        },
        mounted() {
            console.log('file explorer mounted')
            // if (!this.isJSFileExplorerAttached) {
            //     let jqueryScript = document.createElement('script');
            //     jqueryScript.setAttribute('src', require('@/assets/jquery.js'));
            //     document.head.appendChild(jqueryScript)
            //     let tableSortedScript = document.createElement('script');
            //     tableSortedScript.setAttribute('src', require('@/assets/crazyboy-tablesorted.js'));
            //     document.head.appendChild(tableSortedScript)
            //     let splitterScript = document.createElement('script');
            //     splitterScript.setAttribute('src', require('@/assets/crazyboy-splitter.js'));
            //     document.head.appendChild(splitterScript)
            //     let jquery2Script = document.createElement('script');
            //     jquery2Script.setAttribute('src', require('@/assets/crazyboy-jquery.js'));
            //     document.head.appendChild(jquery2Script)
            //     let dinaTreeScript = document.createElement('script');
            //     dinaTreeScript.setAttribute('src', require('@/assets/crazyboy-dynatree.js'));
            //     document.head.appendChild(dinaTreeScript)
            //     store.setJSAttached(true)

            //     let dataScript = document.createElement('script');
            //
            //     dataScript.setAttribute('src', require('@/assets/crazyboy-data.js'));
            //     this.child = dataScript;
            //     document.head.appendChild(dataScript)
            // //     this.datosCargados = true
            setTimeout(function () {
                initF()
                // $(window).on('resize', f);
            }, 2000)
        },
    }
</script>

<style type="text/css">
    h1 {
        /*font-family: 'trebuchet ms', verdana, arial;*/
        /*padding: 10px;*/
        /*padding-top:12px;*/
        /*padding-bottom:0px;*/
        /*margin: 0*/
    }

    /*a img {*/
    /*    border: none;*/
    /*}*/

    .top {
        width: 90%;
        height:80px;
        /*background-color:#eee;*/
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 20px;

        /*border-left: 1px solid #aaa;*/
        /*border-right: 1px solid #aaa;*/

        /*background-image: rgb(246,248,249);*/
        /*background-image: -moz-linear-gradient(top, rgb(246,248,249) 0%, rgb(215,222,227) 99%);*/
        /*background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgb(246,248,249)), color-stop(99%,rgb(215,222,227)));*/
        /*background-image: -webkit-linear-gradient(top, rgb(246,248,249) 0%,rgb(215,222,227) 99%);*/
        /*background-image: -o-linear-gradient(top, rgb(246,248,249) 0%,rgb(215,222,227) 99%);*/
        /*background-image: -ms-linear-gradient(top, rgb(246,248,249) 0%,rgb(215,222,227) 99%);*/
        /*filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f6f8f9', endColorstr='#d7dee3',GradientType=0 );*/
        /*background-image: linear-gradient(top, rgb(246,248,249) 0%,rgb(215,222,227) 99%);*/

    }
    .top a {
        color: #900;
    }
    /*.top_icon {*/
    /*    background: url(data:image/png;base64,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)*/
    /*    no-repeat;*/

    /*    margin:10px;*/
    /*    margin-left:16px;*/
    /*    float:left;*/
    /*    width:48px;*/
    /*    height:48px;*/
    /*}*/
    /*.top_search {*/
    /*    float:right;*/
    /*    padding:10px;*/
    /*}*/
    .top_appinfo {
        padding: 10px;
        padding-top:0px;
        /*font-style: italic;*/
        font-family: Lato-Regular;
        color: var(--secondary-color)
    }

    .loading {
        background:#fff;
        border: 1px solid #aaa;
        margin-left: auto;
        margin-right: auto;
        width: 90%;
        height:90%;
        padding-top:30px;
        text-align:center;
        font-size:120%;
    }
    .loading_info {
        font-size:80%;
        font-style: italic;
    }

    .content {
        display:none;
        width: 90%;
        padding:0px;
        margin-left: auto;
        margin-right: auto;
        background: white;
        border: none;
        border-left: 1px solid #aaa;
        border-right: 1px solid #aaa;
        border-bottom: 1px solid #aaa;
    }

    .tree_div {
        position:relative;
        height: 100%!important;
        width:29%;
        float:left;
        overflow:auto;
        border-top: 1px solid #aaa;
        background-color: black;
    }

    .files_div {
        position:relative;
        height: 100%;
        overflow: auto;
        border-top: 1px solid #aaa;
        border-right: 1px solid #aaa;
        border-bottom: 1px solid #aaa;
        background-color: #1f1f29;
    }

    .bold {
        font-weight: bold;
    }

    /* --- Splitter --- */

    .vsplitbar {
        width: 4px;
        background: #17171e;
        border-right: 1px solid #bbb;
        border-left: 1px solid #bbb;
    }

    /* --- File Table --- */

    table.tablesorter {
        font-family:arial;
        background-color: #CDCDCD;
        font-size: 8pt;
        width: 100%;
        text-align: left;
        border-spacing: 0px;
        /*border-bottom: 1px solid #CCC;*/
    }
    table.tablesorter thead tr th, table.tablesorter tfoot tr th {
        /*background: #FFEFCC;*/
        background: #17171e; /*table header background*/
        border-left: 1px solid #424242;
        border-right: 1px solid #424242;
        padding: 4px;
        border-left: 0px;
    }

    table.tablesorter thead tr .header {
        /*background-image: url(tree_tablesorter_bg.gif);*/
        background-image: url("data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAJCAYAAADdA2d2AAAABmJLR0QA/wD/AP+gvaeTAAAACXBI WXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5QIHFy81MIwC8wAAAFZJREFUKM+1kkEKwDAIBCehL+4p P0gu7Ze311IwbgJdEBF0cFEk4cTVu9zeiqF7DL1zpuoCo3oZGgEycJEsR0s6djYFOFsrW/ajwRnQ OtQXkAEB+ONPH+YYmQMVCPcWAAAAAElFTkSuQmCC");
        background-repeat: no-repeat;
        background-position: center right;
        cursor: pointer;
        /*color: black;*/
    }
    table.tablesorter tbody td {
        /*color: black;*/
        color: #9E9E9E;
        vertical-align: top;
        background: #1f1f29;
        border-bottom: none;
        border-left: none;
        /*border-right: 1px solid #CCC;*/
        /*border-top: 1px solid #DDD;*/
        padding: 3px 3px 3px 4px;
    }

    /*table.tablesorter tbody td:nth-child(1){*/
    /*    width: 20% !important;*/
    /*}*/

    /*td:nth-child(even), th:nth-child(even) {*/
    /*    width: 20% !important;*/
    /*}*/
    /*td:nth-child(odd), th:nth-child(odd) {*/
    /*    width: 60% !important;*/
    /*}*/

    table.tablesorter tbody td:nth-child(1), table.tablesorter thead th:nth-child(1){
        width: 60% !important; /*name*/
    }
    table.tablesorter tbody td:nth-child(2), table.tablesorter thead th:nth-child(2){
        width: 15% !important; /*size*/
    }
    table.tablesorter tbody td:nth-child(0), table.tablesorter thead th:nth-child(0){
        width: 25% !important; /*modified*/
    }
    table.tablesorter tbody tr:nth-child(even) td {
        background: #17171e;; /* even rows background*/
    }
    table.tablesorter thead tr .headerSortUp {
        /*background-image: url(tree_tablesorter_asc.gif);*/
        background-image: url(data:image/gif;base64,R0lGODlhFQAEAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAQAAAINjB+gC+jP2ptn0WskLQA7);
    }
    table.tablesorter thead tr .headerSortDown {
        /*background-image: url(tree_tablesorter_desc.gif);*/
        background-image: url(data:image/gif;base64,R0lGODlhFQAEAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAQAAAINjI8Bya2wnINUMopZAQA7);
    }
    table.tablesorter thead tr .headerSortDown, table.tablesorter thead tr .headerSortUp {
        background-color: #FFD283;
    }

    table.tablesorter th:last-of-type,
    table.tablesorter td:last-of-type {
        border-right:0px;
    }

    span.file, span.file_folder {
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAYUlEQVR4nGNkYGBgqKmp+c+AB7S0tDCiCNTU1PzHBdavX/8f2UAmfCbDgLGxMdwVRGlA1sRCSGFAQACcffbsWeJtgAE6afj+/TtRir9//z5o/UAKYGRgYGAoLi7Gm/iQAQC+qjWGF5ecJwAAAABJRU5ErkJggg==)
        no-repeat
        left center;
        padding-left:16px;
        padding-bottom:1px;
        padding-top:1px;
        color: white;
    }

    span.file_folder {
        background: url(data:image/gif;base64,R0lGODlhEAAOALMIAOC6eJdaH61zLZ9oJMOHNP/Sg//inv///////wAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAAAgALAAAAAAQAA4AAAQ9EMlJq72XaIKnOOAhdIRhFgCwaRQRviE3lWZtB5Rg78bo8TafZFAoGo8DSuDILOAmAUHT+JwMrthsZ4uIAAA7)
        no-repeat
        left center;
    }

    span.file a, span.file_folder a {
        text-decoration: none;
        /*color: #333;*/
        color: white
    }

    span.file a:hover, span.file_folder a:hover {
        text-decoration: underline;
        /*color: #900;*/
    }

    .path_info {
        /*background: #fff;*/
        background: #1f1f29;
        color: white;
        font-family: arial;
        font-size: 8pt;
        border: 0px;
        /*border-bottom: 1px solid #CCC;*/
        border-bottom: 1px solid #616161;
        padding:3px;
        padding-left: 6px;
    }
    .path_divider {
        display:inline-block;
        margin-left: 3px;
        margin-right: 2px;
        margin-bottom: 1px;
        width: 0px;
        height: 0px;
        border-style: solid;
        border-width: 3px 0 3px 5px;
        border-color: transparent transparent transparent #9E9E9E;
    }

    .num_files {
        padding: 8px 0 8px 10px;
        margin-top: 25px;
        color: white;
        font-family: Lato-Regular;
        font-size: 9pt;
        border-top: 1px solid #616161;
    }

    /* --- DynaTree --- */
    ul.dynatree-container
    {
        white-space: nowrap;
        padding: 0px;
        margin: 0; /* issue 201 */
        background-color: #17171e;
        border: 0px dotted gray;
        overflow: auto;
        height: 100%; /* issue 263 */
    }

    ul.dynatree-container ul
    {
        padding: 0 0 0 16px;
        margin: 0;
    }

    ul.dynatree-container li
    {
        list-style-image: none;
        list-style-position: outside;
        list-style-type: none;
        -moz-background-clip:border;
        -moz-background-inline-policy: continuous;
        -moz-background-origin: padding;
        background-attachment: scroll;
        background-color: transparent;
        background-repeat: repeat-y;
        /* vline.gif */
        background-image:url(data:image/gif;base64,R0lGODlhEAAQAPcAAAAAAIAAAACAAICAAAAAgIAAgACAgMDAwMDcwKbK8P///6Wlpf/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////78KCgpICAgP8AAAD/AP//AAAA//8A/wD//////yH5BAEAAP4ALAAAAAAQABAAAAgpAP0JFHhvoMGDCBMiLKiwocOBDB9KXDixosGIFidizPhwI8eGHj8KDAgAOw==);
        background-position: 0 0;
        margin: 0;
        padding: 1px 0 0 0;
    }
    ul.dynatree-container li.dynatree-lastsib
    {
        background-color: #17171e; /*sidebar background color*/
        background-image: none;
    }
    ul.dynatree-no-connector > li
    {
        background-image: none;
    }

    a.dynatree-title {
        color: white !important;
        font-size: 10pt;
    }
    a.dynatree-title:hover {
        background-color: black !important;
        border: none !important;
    }
    .ui-dynatree-disabled ul.dynatree-container
    {
        opacity: 0.5;
        background-color: silver;
    }
    span.dynatree-empty,
    span.dynatree-vline,
    span.dynatree-connector,
    span.dynatree-expander,
    span.dynatree-icon,
    span.dynatree-checkbox,
    span.dynatree-radio,
    span.dynatree-drag-helper-img,
    #dynatree-drop-marker
    {
        width: 16px;
        height: 16px;
        display: inline-block; /* Required to make a span sizeable */
        vertical-align: top;
        background-repeat: no-repeat;
        background-position: left;
        /* icons.gif */
        background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABwCAYAAACuE3ZzAAAC8UlEQVR4nO3ZPWjUYBzH8W+06FAo hwiKqxUcxEFE3aSDL0OH0i4OgpK4KE4qIgXRTSdRHBRpohZ8q1Rw8BUER8HByak6CoKCHaQiVR6H J4+kadJEc/HuzO+zXPPyS3O5f/6X5zkQEREREREREREREREREREREREREREREREREREREREREfmf GGMwxjA9PWGqHKdqvmPcBWiSZVkrVQENogpIUgXE3CdY9rXd+Y5RBcS67pP5V1QBMVVAg6gCklQB MVVAg+RVwEyVg/ZsvokV4CUXwjDcCxwDbgK33PpWywyOjR16l3cQYwxRFGVmAXzfx/O8zKzLF55o Tfm+1PJaYBcwBKwArhceuWI2DEOiKNoEvAe+ZeyyHNgchuGbIAjank/3gBvACPAViICzZd5Exewg MAnsz9m+B5gCttaRz2qCD4HdwAxwBpiYn2cg5+CFWaBVkFkJDADXgOHUti3Y22k1sKqOfOa3APAa 2Am8AoK5Oe8yZI7ns7rtgixw321w+6fyb4GjwBfgDrAj3n0wPvkWcAJ4XkPepJtgcnEd8ADY7nm8 9P1gKOdiuSaYmQUe+b4/nNeEEv9zH7aUP2Av3ClsTzkHjAPk9YAq+XQTdLYBt4H1wJX+fnM1Z7/C LHCyZO4usAa4CLyI100Cp+vMZ90CI8Az7BsYB4709TFX8iQWZbFNsaxLwPn47yfAceBnnfl0BRzE fn39AA5gr2BZVbJJF7D37RTwue58+gJ8BB5jT/6eWzk76+U+BIF9yAjDMDPrtufJuC8/AYcLzrtt +QUSvw325rN81XwTxwJd+ctQx/KqgFjP3sNV802sgFLzAZD9GOloPqBCVvMBvTAfQPGYvkq2++cD iMf0OePxUtkl8h2dD8gbDoNtkK5zfI8bzQZjAgAvfnXLS2bhd6NalI/nEZ5iR46T8Ztw4/mN2PF8 CDA6GrQ775WaD6D8mL5KtnvnAyg/ptd8wF9mk7pvPqCkv8r6vp9e9Ufj+ap5kYb7BWc+TrFpDk1L AAAAAElFTkSuQmCC");
        background-position: 0 0;
    }
    ul.dynatree-container img
    {
        width: 16px;
        height: 16px;
        margin-left: 3px;
        vertical-align: top;
        border-style: none;
    }
    span.dynatree-connector
    {
        background-position: -16px -64px;
    }
    span.dynatree-expander
    {
        background-position: 0px -80px;
        cursor: pointer;
    }
    .dynatree-exp-cl span.dynatree-expander /* Collapsed, not delayed, last sibling */
    {
        background-position: 0px -96px;
    }
    .dynatree-exp-cd span.dynatree-expander /* Collapsed, delayed, not last sibling */
    {
        background-position: -64px -80px;
    }
    .dynatree-exp-cdl span.dynatree-expander /* Collapsed, delayed, last sibling */
    {
        background-position: -64px -96px;
    }
    .dynatree-exp-e span.dynatree-expander,  /* Expanded, not delayed, not last sibling */
    .dynatree-exp-ed span.dynatree-expander  /* Expanded, delayed, not last sibling */
    {
        background-position: -32px -80px;
    }
    .dynatree-exp-el span.dynatree-expander,  /* Expanded, not delayed, last sibling */
    .dynatree-exp-edl span.dynatree-expander  /* Expanded, delayed, last sibling */
    {
        background-position: -32px -96px;
    }
    .dynatree-loading span.dynatree-expander  /* 'Loading' status overrides all others */
    {
        background-position: 0 0;
        /*background-image: url("loading.gif");*/
    }
    span.dynatree-icon /* Default icon */
    {
        margin-left: 3px;
        background-position: 0px 0px;
    }
    .dynatree-ico-cf span.dynatree-icon  /* Collapsed Folder */
    {
        /*background-position: 0px -16px;*/
        background: url(data:image/gif;base64,R0lGODlhEAAOALMIAOC6eJdaH61zLZ9oJMOHNP/Sg//inv///////wAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAAAgALAAAAAAQAA4AAAQ9EMlJq72XaIKnOOAhdIRhFgCwaRQRviE3lWZtB5Rg78bo8TafZFAoGo8DSuDILOAmAUHT+JwMrthsZ4uIAAA7)
    }
    .dynatree-ico-ef span.dynatree-icon  /* Expanded Folder */
    {
        /*background-position: -64px -16px;*/
        background:url(data:image/gif;base64,R0lGODlhEAAOALMIAJdaH+C6eJ9oJMOHNK1zLf/inv/Sg////////wAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAAAgALAAAAAAQAA4AAARAEMlJq7136IEnOeBBdENhGkGwadQQviE3lWZtAxRhE3zvIzpT0HYaCQwGAnLJHCEASabU+VRKl1SJYMvtdr6ICAA7);
    }
    span.dynatree-node
    {
        /*	display: -moz-inline-box; /* issue 133, 165, 172, 192. removed for issue 221*/
        /*	-moz-box-align: start; /* issue 221 */
        /*  display: inline-block; /* Required to make a span sizeable */
    }
    ul.dynatree-container a
    {
        color: black; /* inherit doesn't work on IE */
        text-decoration: none;
        vertical-align: top;
        margin: 0px;
        /*margin-left: 3px;*/
        border: 1px solid transparent;
        /*	outline: 0; /* @ Firefox, prevent dotted border after click */
    }
    ul.dynatree-container a:hover
    {
        /*	text-decoration: underline; */
        background-color: #E9EDEF;
        border: 1px solid #aaa;
    }
    span.dynatree-node a
    {
        /*font-size: 10pt; /* required for IE, quirks mode */
        display: inline-block; /* Better alignment, when title contains <br> */
        padding-left: 2px;
        padding-right: 3px; /* Otherwise italic font will be outside bounds */
    }
    span.dynatree-folder a
    {
    }
    ul.dynatree-container a:focus,
    span.dynatree-focused a:link  /* @IE */
    {
    }
    span.dynatree-has-children a
    {
    }
    span.dynatree-expanded a
    {
    }
    span.dynatree-selected a
    {
    }
    span.dynatree-active a
    {
        font-weight: bold;
        /*background-color: #3169C6 !important;
        color: white !important; /* @ IE6 */
    }

    @media screen and (max-width: 600px){
        .tree_div {
            position:relative !important;
            height: 50%!important;
            width:100% !important;
            float:none;
            z-index: 0 !important;
            /*overflow:auto;*/
            /*border-top: 1px solid #aaa;*/
            /*background-color: black;*/
        }

        .files_div {
            position:relative !important;
            z-index: 0 !important;
            height: 50% !important;
            width: 100% !important;
            left: 0 !important;
            /*overflow: auto;*/
            /*border-top: 1px solid #aaa;*/
            /*border-right: 1px solid #aaa;*/
            /*border-bottom: 1px solid #aaa;*/
            /*background-color: #1f1f29;*/
        }

        .vsplitbar {
            display: none;
        }

    }
</style>

